import { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Button } from '../../../common/html/button'
import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'
import { getUnique } from '../../../helpers/common'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { useHandshakesWidget } from '../../common/widget/useHandshakesWidget'
import { CONNECT_MAP_TYPE, FILTER_BY } from '../../constant'
import { uploadFileConnectMap } from '../../entityMap/store/thunk'
import { convertBase64ToFile } from '../../helper'
import { resetState, selectFilter } from '../store/slice'
import {
  createConnectionMapLogs,
  updateConnectionMapLogs,
} from '../store/thunk'
import { DegreeSelect } from './DegreeSelect'
import classes from './index.module.scss'

const Content = () => {
  const dispatch = useDispatch()
  const handshakesWidgetId = useRef(null)
  const filter = useSelector(selectFilter())
  const { filterBy, searchCompanyAndPerson, degree } = filter
  const [isShowDegree, setShowDegree] = useState(false)
  const [loading, setLoading] = useState(false)
  const widgetInstance = useHandshakesWidget('#hs-widget')

  const disableView = useMemo(() => {
    return (
      searchCompanyAndPerson.length < 2 || searchCompanyAndPerson.length > 10
    )
  }, [filterBy, searchCompanyAndPerson])

  const handleLoadWidget = () => {
    if (widgetInstance && !disableView) {
      const id = getUnique()
      const datasets = ['CRVN']
      const entities = searchCompanyAndPerson.map((item) => ({
        dataset: 'CRVN',
        id:
          (item.type === FILTER_BY.COMPANY ? 'O' : 'P') +
          '-' +
          (item.type === FILTER_BY.COMPANY
            ? item.organizationId
            : item.personId),
      }))
      dispatch(
        createConnectionMapLogs({
          requestId: id,
          graphType: 'interconnect',
          datasets: JSON.stringify(datasets),
          entities: JSON.stringify(entities),
          degree,
        }),
      )
      handshakesWidgetId.current = id
      setLoading(true)
      setShowDegree(false)
      widgetInstance.drawGraphWithEndpointData({
        graphType: 'interconnect',
        datasets,
        entities,
        degree,
      })
    }
  }

  useEffect(() => {
    if (widgetInstance && degree && !disableView) {
      handleLoadWidget()
    }
  }, [degree])

  useEffect(() => {
    window.hswidget_handleShowStatus = function (data) {
      setShowDegree(true)
      setLoading(false)
      if (data?.data?.base64String) {
        const fileType = data?.data?.fileType || 'pdf'
        const nameFile =
          [
            'FG',
            CONNECT_MAP_TYPE.INTERCONNECTION_MAP,
            formatDateTime(new Date(), FORMAT.FILE_DOWNLOAD),
          ].join('_') +
          '.' +
          fileType
        const file = convertBase64ToFile(
          data?.data?.base64String,
          nameFile,
          fileType,
        )
        dispatch(uploadFileConnectMap(file))
      } else {
        dispatch(
          updateConnectionMapLogs({
            requestId: handshakesWidgetId.current,
            responseStatusCode: data?.code,
            responseMessage: data?.message,
            responseNodeCount: data?.data?.graph?.nodes?.length,
            responseEdgeCount: data?.data?.graph?.edges?.length,
          }),
        )
      }
    }
    return () => {
      delete window.hswidget_handleShowStatus
    }
  }, [])

  useEffect(() => {
    dispatch(resetState())
  }, [])

  if (!searchCompanyAndPerson.length) {
    return (
      <Element
        className="textCenter mt5 pt5 fw500"
        style={{ fontSize: 20, color: '#9C9C9C' }}
      >
        <Translate value="connectMap.interconnectionMap.PLEASE_SELECT" />
      </Element>
    )
  }

  return (
    <div className="mt1 h100">
      <Element className="dFlex alignItemsCenter gap1 mb1">
        <Button
          label="connectMap.interconnectionMap.VIEW"
          className={`${classes.btnView} ${disableView ? classes.disable : ''}`}
          disabled={false}
          action={handleLoadWidget}
          isI18n
        />
        {disableView ? (
          <Translate
            style={{
              color: '#E0505B',
            }}
            value="connectMap.main.PLEASE_SELECT_VALIDATION"
          />
        ) : null}
      </Element>
      <div className="positionRelative h100">
        {isShowDegree && <DegreeSelect />}
        {loading && <Loading />}
        <div
          id="hs-widget"
          style={{ height: loading ? 0 : 'calc(100vh - 270px)' }}
        ></div>
      </div>
    </div>
  )
}

export default Content
